import { CardStatus, ProductionInfoFragment } from 'src/graphql'

const selectableCards = (card: ProductionInfoFragment) => {
  return (
    card.status !== CardStatus.FULFILLED && card.status !== CardStatus.REJECTED
  )
}

export default selectableCards
